import React from 'react';
import { Box, Typography } from '@mui/material';
import { CompanyShortDto } from '../../models/companies/companyShortDto';
import { DateUtils } from '../../helpers/dateUtils';
import TmFullButton from '../common/buttons/TmFullButton';
import { RiskGroupDto } from '../../models/medicalCheckups/riskGroupDto';
import TmPrinter from '../../icons/TmPrinter';

interface RiskGroupHeaderProps {
    fromDate: string;
    toDate: string;
    company: CompanyShortDto | null;
    data: RiskGroupDto | null;
    onExport: () => void;
}

export const RiskGroupHeader: React.FC<RiskGroupHeaderProps> = ({
    fromDate,
    toDate,
    company,
    data,
    onExport
}) => {
    return (
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2} mt={2}>
            <Box>
                {fromDate && toDate && (
                    <Typography variant="body2" color="text.secondary">
                        Период: с {DateUtils.formatDate(fromDate)} по {DateUtils.formatDate(toDate)}
                    </Typography>
                )}
                {company && (
                    <Typography variant="body2" color="text.secondary">
                        Организация: <span style={{ fontWeight: 'bold' }}>{company.name}</span>
                    </Typography>
                )}
            </Box>
            <TmFullButton
                sx={{ minWidth: 180 }}
                disabled={!data?.drivers?.length}
                onClick={onExport}
                startIcon={<TmPrinter />}
            >
                Скачать
            </TmFullButton>
        </Box>
    );
}; 